import React, { useState, useEffect, useCallback } from "react";
import { ButtonGroup, Button, Dialog, Box, IconButton, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useIntl } from "react-intl";
import CloseIcon from "@mui/icons-material/Close";
import CashPaymentDialog from "./CashPaymentDialog";

function PaymentOptions(props) {
  const [openDialog, setOpenDialog] = useState(false);
  let isPortrait = window.innerWidth < window.innerHeight;
  const [payConfirmDialog, setPayConfirmDialog] = useState(false);
  const { formatMessage: t } = useIntl();
  const [payRef, setPayRef] = useState("");
  const terminalProviders = ['verifone', 'worldline', 'stripe', 'powertranz'];
  console.log(props);
  const getTotalPrc = () => {
    if (!props.order) return 0;
    //  console.log(props.order.totalPrice);
    // if (props.order.discountType) {
    //   if (props.order.discountType === "percentage") {
    //     return props.order.totalPrice - (props.order.totalPrice * (props.order.discountAmount / 100));
    //   } else {
    //     return props.order.totalPrice - props.order.discountAmount;
    //   }
    // } else {
    return props.order.totalPrice;
    //}
  };


  var nextID = 0;

  // Function that creates a query string for a URL
  const encodeQueryData = (data) => {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }

  const event_handler = useCallback((event) => {
    try {
      console.info('EVENT: Received event-----', event);

      var data;
      data = event.data;
      console.log(data);

      if (data && typeof data == 'string' && JSON.parse(data)?.result == "SUCCESS") {
        console.log('closing', props?.order);
        //setPayRef(data);
        if (props?.handlePayMode) {
          props.handlePayMode("CARD", props.order, data);
        } else {
          console.warn("handlePayMode is undefined in props");
        }
        setPayConfirmDialog(false);
      } else if (data && typeof data == 'string' && (JSON.parse(data)?.result == "FAILURE" || JSON.parse(data)?.result == "CANCELLED" || JSON.parse(data)?.result == "NOCONNECTION")) {
        setPayConfirmDialog(false);
      }


      // $('#myModal').modal('hide');
      // $('#myModal').data('bs.modal', null);
      //document.getElementById('refID').value = Date.now();
    }
    catch (e) {
      console.log(e);
    }
  }, [props.handlePayMode, props.order]);

  const process_result = (state) => {
    document.getElementById('lastRefID').innerHTML = state.reference_id;
    document.getElementById('lastResult').innerHTML = state.result;
    document.getElementById('lastMessage').innerHTML = state.final_message;
    document.getElementById('lastReceipt').innerHTML = state.receipt;
  }

  const purchase_tx = () => {

    const merchantId = props.userData.merchantCode;
    const amount = (parseFloat(props.order.totalPrice) + parseFloat(props.cashout || 0));
    console.log(amount);


    if (props.userData.paymentProviderType.toLowerCase() == 'fygaro') {

      setPayConfirmDialog(`https://www.fygaro.com/en/pb/${props.userData.paymentProviderCode}/+?amount=${props.order.totalPrice}&client_note=digifyPoS&client_reference=${props.order.invoicePath || new Date().getTime()}&return_url=https://www.fygaro.com/`);
    } else if (props.userData.paymentProviderType.toLowerCase() == 'verifone') {
      let data = {
        amount,
        cash_amount: parseFloat(props.cashout || 0),
        reference_id: Math.random().toString(36).substring(2, 10),
        register_id: props.userData.firstName,
        merchant_id: merchantId
      };
      console.log(data);
      let queryStr = encodeQueryData(data);
      setPayConfirmDialog('https://vcloud.alt-payment.com/webint/purchase/NextOrder?' + queryStr);
      // $('#myModal').modal('show');
    }
  }

  const refund_tx = (transData) => {
    const merchantId = props.userData.merchantCode;
    const amount = (parseFloat(props?.order?.totalPrice) + parseFloat(props?.cashout || 0));
    var refID = Math.random().toString(36).substring(2, 10);
    var regID = props.userData.firstName;
    var merchID = merchantId;

    let data = { 'amount': amount, 'reference_id': refID, 'register_id': regID, 'merchant_id': merchID };
    let queryStr = encodeQueryData(data);

    setPayConfirmDialog('https://vcloud.alt-payment.com/webint/refund/NextOrder?' + queryStr);
    // $('#myModal').modal('show');
  }

  // const demo_pair =()=> {
  //     var regID = new Date().getTime();
  //     var merchID = 'WEE23';
  //     var merchName = 'DEMORESTAU';

  //     let data = { 'register_id': regID, 'merchant_id': merchID };
  //     if (merchName!="")
  //     {
  //         data["merchant_name"] = merchName;
  //     }

  //     let queryStr = encodeQueryData(data);

  //     document.getElementById('pairFrame').src = 'https://vcloud-dev.alt-payment.com/webint/config/NextOrder/4dd84130-5982-4303-aa9f-3824f80c37cf?' + queryStr;

  // }
  // useEffect(() => {
  //  demo_pair();
  // }, [openPairingDialog]);
  // Listen for postMessage events from Vend, if requesting extra sale data then
  // this is where you can handle the sale JSON.

  //document.getElementById('refID').value = Date.now();
  useEffect(() => {
    if (props?.userData?.paymentProviderType?.toLowerCase() == 'verifone') {
      const listener = (event) => event_handler(event);
      window.addEventListener('message', listener, false);
      return () => window.removeEventListener('message', listener);
    }
  }, [props?.userData?.paymentProviderType, event_handler]);


  const allPaymentMethods = [
    { value: "0", label: "CASH" },
    { value: "1", label: "QR/SCAN" },
    { value: "2", label: "CARD" },
    { value: "3", label: "COUPON" },
    { value: "4", label: "CREDIT" },
  ];

  const enabledMethods = props.userData?.paymentMethods
    ? allPaymentMethods.filter(m => props.userData.paymentMethods.split(",").includes(m.value))
    : allPaymentMethods.slice(0, 3); // Default to Cash, UPI, Card if not set

  return (
    <div style={{ padding: "20px 10px", width: "100%", }}>
      {props.order && props.order.orderItems.length && (

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", gap: 2 }}>
          <FormControl fullWidth size="small" style={{ border: "0px", width: "150px" }} >
            <InputLabel style={{ color: "#b6a10a", background: "#1f2631" }} id="payment-method-label">{t({ id: "payment_method" }) || "Payment Method"}</InputLabel>
            <Select
              labelId="payment-method-label"
              id="payment-method-select"
              className="btn-border"
              value={props.payModeIndx || 0}
              label={t({ id: "payment_method" }) || "Payment Method"}
              onChange={(e) => {
                const method = e.target.value;
                props.setPayModeIndx(parseInt(method));
                if (method === '0') {
                  setOpenDialog(true);
                }
              }}
            >
              {enabledMethods.map((m) => (
                <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {props.order && props.order.orderItems.length && props.userData.paymentProviderType && <img
            height="auto"
            width="70px"
            alt=""
            style={{ height: "auto", cursor: "pointer" }}
            src={"/swiping.svg"}
            onClick={() => props?.order?.orderType.toLowerCase() == 'refund' ? refund_tx() : purchase_tx()}
          />}
          <Button
            variant="outlined"
            className="btn-border"
            style={{ color: "#b6a10a!important" }}
            sx={{ whiteSpace: 'nowrap' }}
            onClick={() => {
              const modeMap = {
                0: "CASH",
                1: "UPI",
                2: "CARD",
                3: "COUPON",
                4: "CREDIT"
              };
              props.handlePayMode(modeMap[props.payModeIndx] || "CASH");
            }}
          >
            {t({ id: "mark_paid" }) || "Mark Paid"}
          </Button>
        </Box>
      )}

      {/* Cash Payment Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        style={{ zIndex: 9999999 }}
      >
        <Box sx={{ border: 1, p: 1, bgcolor: "background.paper" }}>
          <IconButton
            onClick={() => setOpenDialog(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <CashPaymentDialog
            setCashPayDialog={() => setOpenDialog(false)}
            handlePayMode={(method, order, data, splitPayMode, splitPayAmnt) => {
              props.handlePayMode(method, props.order, data, splitPayMode, splitPayAmnt);
              props.closeParentDialog(); // Close parent dialog when cash payment is completed
            }}
            totalAmount={getTotalPrc()}
            order={props.order}
            cashout={props.cashout}
          />
        </Box>
      </Dialog>

      <Dialog
        open={payConfirmDialog}
        style={{ zIndex: 9999999 }}
      >
        <div class="modal-body" style={{ height: "600px" }}>
          <iframe id="txFrame" src={payConfirmDialog} frameborder="0" allowtransparency="true" style={{ width: "100%", height: "100%" }}></iframe>
        </div>
      </Dialog>
    </div>
  );
}

export default PaymentOptions;
